import React from 'react'
import {Link as RouteLink} from 'react-router-dom'
// Components
import {
    Breadcrumb as ChakraBreadcrumb,
    BreadcrumbItem as ChakraBreadcrumbItem,
    BreadcrumbLink as ChakraBreadcrumbLink,
    Link,
    // Hooks
    useStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {pxToRem} from '../../../../utills/pxToRem'
import {breadcrumbItemStyle} from '../../../../components/breadcrumb/index.style'

/**
 * A simplification of the Chakra `Breadcrumb` component for our project needs. Given
 * a list of categories, display a breadcrumb and it's items.
 */
const GiftCardBreadcrumb = () => {
    const styles = useStyleConfig('Breadcrumb')

    return (
        <ChakraBreadcrumb
            margin={`${pxToRem(15)} ${pxToRem(10)}`}
            className="sf-breadcrumb"
            {...styles.container}
            separator={<span>/</span>}
            sx={{
                ol: {
                    flexWrap: 'wrap'
                }
            }}
        >
            <ChakraBreadcrumbItem sx={breadcrumbItemStyle} data-testid="sf-crumb-item">
                <ChakraBreadcrumbLink as={Link} href={'/'} {...styles.link}>
                    Home
                </ChakraBreadcrumbLink>
            </ChakraBreadcrumbItem>

            <ChakraBreadcrumbItem sx={breadcrumbItemStyle} data-testid="sf-crumb-item">
                <span>Gift Card</span>
            </ChakraBreadcrumbItem>
        </ChakraBreadcrumb>
    )
}

GiftCardBreadcrumb.displayName = 'Breadcrumb'

export default GiftCardBreadcrumb
